export const CampaignAudienceCriterion = {
  properties: {
    CriterionType: {
      'bulk-upload-header': 'Type',
      'bulk-upload-mapper': function (value) {
        switch (value) {
          case 'Remessaging':
            return 'Campaign Remarketing List Association';
          case 'NegativeRemessaging':
            return 'Campaign Negative Remarketing List Association';
          case 'Custom':
            return 'Campaign Custom Audience Association';
          case 'NegativeCustom':
            return 'Campaign Negative Custom Audience Association';
          case 'InMarket':
            return 'Campaign In Market Audience Association';
          case 'NegativeInMarket':
            return 'Campaign Negative In Market Audience Association';
          case 'Product':
            return 'Campaign Product Audience Association';
          case 'NegativeProduct':
            return 'Campaign Negative Product Audience Association';
          case 'RemarketingSimilar':
            return 'Campaign Similar Remarketing List Association';
          case 'NegativeRemarketingSimilar':
            return 'Campaign Negative Similar Remarketing List Association';
          case 'CustomerList':
            return 'Campaign Customer List Association';
          case 'NegativeCustomerList':
            return 'Campaign Negative Customer List Association';
          case 'CombinedList':
            return 'Campaign Combined List Association';
          case 'NegativeCombinedList':
            return 'Campaign Negative Combined List Association';
          case 'ImpressionBasedRemarketing':
            return 'Campaign Impression Based Remarketing List Association';
          case 'NegativeImpressionBasedRemarketing':
            return 'Campaign Negative Impression Based Remarketing List Association';
          case 'AIPrompt':
            return 'Campaign AI Prompt Association';
          case 'NegativeAIPrompt':
            return 'Campaign Negative AI Prompt Association';
          default:
            return 'Campaign Unknown Association';
        }
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
  },
};
